<template>
   <div class="btnBox ft16 row cen-center gray-6" :class="{'btnOrgin':btnCol}">
      {{btnText}}
   </div>
</template>
<script>
export default {
  name: 'btn',
   data(){
        return {
           
        }
    }, 
    props: {
        btnCol:{ // 颜色
            type: Boolean,
            default() { return false; }
        },
        btnText:{ //  文字
            type: String,
            default() { return ''; }
        },
    },
}
</script>
<style lang="less" scoped>
.btnBox{
    width: 100%;
    height: 2.5rem;
    background:rgba(209,209,209,1);
    border-radius:5px;
}
.btnOrgin{
    height: 2.5rem;
    background:linear-gradient(90deg,rgba(253,123,49,1),rgba(240,130,67,1));
    box-shadow:0px 3px 7px 3px rgba(253,123,49,0.43);
    border-radius:5px;
    color: #fff;
}
</style>
